import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SplitType from 'split-type';
import BaseModule from '../../../javascripts/helpers/baseModule';

export default class ScrollingText extends BaseModule {
  constructor(element) {
    super(element, 'scrolling-text', [
      { selector: 'sticky', id: 'sticky' },
      { selector: 'text', id: 'text' }
    ]);
  }

  handleResize() {
    this.cleanupTimeline();
    this.splittedText.revert();
    this.splitText();
    this.createTimeline();
  }

  splitText() {
    this.splittedText = new SplitType(this.elements.text, { types: 'lines, words' });
    this.splittedText.lines.forEach((line) => {
      const mask = document.createElement('div');
      mask.classList.add('line-mask');
      line.append(mask);
    });
  }

  createTimeline() {
    this.splittedText.lines.forEach((line) => {
      const triggerElement = line;
      const targetElement = triggerElement.querySelector('.line-mask');

      this.timeline = gsap.timeline({
        scrollTrigger: {
          trigger: triggerElement,
          start: 'top center',
          end: 'bottom center',
          scrub: 1,
          once: true
        }
      });

      this.timeline.to(targetElement, {
        width: '0%',
        duration: 1
      });
    });
  }

  cleanupTimeline() {
    this.timeline.scrollTrigger.kill();
    this.timeline.kill();
    this.timeline = null;
  }

  init() {
    gsap.registerPlugin(ScrollTrigger);
    this.splittedText = null;
    this.timeline = null;
    this.splitText();
    this.createTimeline();

    window.addEventListener('resize', this.handleResize.bind(this));
  }
}
